import { Link } from 'react-router-dom';
import { filmsData } from '@/mocks/films';
import FilmCard from '@/components/base/FilmCard';

export default function FeaturedFilms() {
  const featuredFilms = filmsData.filter((f) => f.category === 'featured' || f.category === 'top-rated').slice(0, 4);

  return (
    <section className="py-14 md:py-20" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              精选推荐
            </h2>
            <p className="mt-2 text-foreground-600 text-sm">
              编辑团队精心挑选的北条麻妃必看佳作
            </p>
          </div>
          <Link
            to="/category/featured"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {featuredFilms.map((film) => (
            <FilmCard key={film.id} {...film} />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/featured"
            className="inline-flex items-center gap-1.5 text-primary-500 hover:text-primary-600 font-medium text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部精选作品
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}